<template>
  <div>
    <!-- 标签编号编辑 -->
    <el-dialog :title="$t('message.labelNumberEditing')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="content">

        <!-- 标签数量： -->
        <div class="row">
          <div class="label">
            {{ $t("message.numberOfLabels") }}
            ：
          </div>
          <div class="val">
            <el-input v-model="datas.num" onfocus="this.select()" type="number"
              :placeholder="$t('message.numberOfLabels')"></el-input>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    tagData: { type: Object },
  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      datas: {},
      dialogVisible: false,
    };
  },
  methods: {
    //
    handleClick() { },
    // 保存
    save() {
      let datas = {
        porder_detail_tag_id: this.datas.id,
        num: this.datas.num - 0
      }
      this.$api.porderApi.updateTagNum(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
        this.$parent.tagData = null;
        this.$parent.checked = false;
      });
    },
  },
  watch: {
    dialogVisible() {
      if (this.tagData != null) {

        this.datas = this.tagData;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      flex: 1;
      line-height: 40px;
    }

    .val {
      flex: 3;
      line-height: 40px;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 5px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>